import { addHours } from "date-fns";
import { fromZonedTime } from "date-fns-tz";

import { TIMEZONES } from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";

const HOURS_BEFORE_VISIT = 24;

/**
 * Mirrors the server rule in ResolveLateCancellationFeeWaiverAction: a fee applies when the
 * visit had not started yet as of `cancelledAt` and starts within 24 hours of it.
 *
 * `cancelledAt` is the instant the cancellation happened, which is what makes this work for
 * both flows. Cancelling passes "now" because that is when it is happening. Editing passes
 * the ORIGINAL cancellation instant, so replaying the rule days later reaches the verdict the
 * cancellation itself did. Measuring an edit against "now" would always say the fee does not
 * apply, since by then the visit has started.
 *
 * The visit date arrives as "yyyy-MM-dd HH:mm:ss" with no offset, already converted to
 * clinic time by the API. Parsing it with plain date-fns would read it in the browser's
 * timezone and shift the window by the offset for any admin outside Eastern, so it is
 * anchored explicitly instead.
 *
 * The server is authoritative: right at the boundary the two can disagree, and the server
 * rejects a waiver it considers inapplicable.
 */
export const isWithinLateCancellationWindow = (
  visitDate: string,
  cancelledAt: Date = new Date(),
): boolean => {
  const startsAt = fromZonedTime(visitDate, TIMEZONES.ET.iana);

  return (
    startsAt > cancelledAt &&
    startsAt <= addHours(cancelledAt, HOURS_BEFORE_VISIT)
  );
};
